import { customRandom, urlAlphabet, random } from "nanoid";
var nanoid = customRandom(urlAlphabet, 10, random);
export var getCartId = function() {
    return nanoid();
};
